// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pp-0";